// import React from 'react'
import "../components/myStats.css"

// const Git = () => {

// const stat={
//   display:"flex"
// }

//   return (

//  <div id="stats">
//         <h1 style={{
//       paddingTop: "20px",
//       textAlign: "center"
//     }}>My stats</h1>
// <div style={stat}>
       
//         <img align="left" className='imgg' src="https://github-readme-stats.vercel.app/api?username=shashi310&show_icons=true&locale=en&theme=dark&hide_border=false&background=0D1117&stroke=0000&ring=22DD22&fire=DD2222&currStreakLabel=DDDDDD&sideLabels=DDDDDD&dates=DDDDDD" alt="shashi310" />

//       <img align="center" className='imgg' style={{
        
//         marginTop:"18px",
        
//       }} src="https://github-readme-stats.vercel.app/api/top-langs?username=shashi310&show_icons=true&locale=en&layout=compact&theme=dark&hide_border=false&background=0D1117&stroke=0000&ring=22DD22&fire=DD2222&currStreakLabel=DDDDDD&sideLabels=DDDDDD&dates=DDDDDD" alt="shashi310" />
//       <img align="right" className='imgg' src="https://github-readme-streak-stats.herokuapp.com/?user=shashi310&theme=dark&hide_border=false&background=0D1117&stroke=0000&ring=22DD22&fire=DD2222&currStreakLabel=DDDDDD&sideLabels=DDDDDD&dates=DDDDDD" alt="shashi310" />
      
     
// <br />



//       <p style={{
//         textAlign:"center",
//       }}>
//       <img align="center" className='imgg' src="https://github-readme-activity-graph.vercel.app/graph?username=shashi310&background=0D1117&stroke=0000&ring=22DD22&fire=DD2222&currStreakLabel=DDDDDD&sideLabels=DDDDDD&dates=DDDDDD" alt="shashi310" />
      
//       </p>


//       </div>
//     </div> 


// //     <div id="stats">
// //         <h1 style={{
// //       paddingTop: "20px",
// //       textAlign: "center"
// //     }}>My stats</h1>

// //         <p className='boxx'>
// //         <img align="left" className='imgg' src="https://github-readme-stats.vercel.app/api?username=shashi310&show_icons=true&locale=en&theme=dark&hide_border=false&background=0D1117&stroke=0000&ring=22DD22&fire=DD2222&currStreakLabel=DDDDDD&sideLabels=DDDDDD&dates=DDDDDD" alt="shashi310" />

// //       <img align="center" className='imgg' style={{
        
// //         marginTop:"18px",
        
// //       }} src="https://github-readme-stats.vercel.app/api/top-langs?username=shashi310&show_icons=true&locale=en&layout=compact&theme=dark&hide_border=false&background=0D1117&stroke=0000&ring=22DD22&fire=DD2222&currStreakLabel=DDDDDD&sideLabels=DDDDDD&dates=DDDDDD" alt="shashi310" />
// //       <img align="right" className='imgg' src="https://github-readme-streak-stats.herokuapp.com/?user=shashi310&theme=dark&hide_border=false&background=0D1117&stroke=0000&ring=22DD22&fire=DD2222&currStreakLabel=DDDDDD&sideLabels=DDDDDD&dates=DDDDDD" alt="shashi310" />
      
// //       </p>
// // <br />



// //       <p style={{
// //         textAlign:"center",
// //       }}>
// //       <img align="center" className='imgg' src="https://github-readme-activity-graph.vercel.app/graph?username=shashi310&background=0D1117&stroke=0000&ring=22DD22&fire=DD2222&currStreakLabel=DDDDDD&sideLabels=DDDDDD&dates=DDDDDD" alt="shashi310" />
      
// //       </p>
// //     </div>
//   )
// }

// export default Git








// import React from 'react';
// import GitHubCalendar from "react-github-calendar";

// const styles = {
//   container: {
//     maxWidth: '90%',
//     margin: '0 auto',
//   },
//   box: {
//     backgroundColor: '#095c80',
   
//     marginBottom: '50px',
//     borderRadius: '20px',
//     boxShadow: 'rgb(84, 25, 178) 0px 15px 25px, rgb(26, 201, 47) 0px 5px 10px',
//     transition: '.3s ease-in-out 0s',
//   },
//   boxHover: {
//     transform: 'scale(1.03)',
//   },
//   innerBox: {
//     width: '100%',
//     margin: 'auto',
//     color: 'white',
//     padding: '10px',
//   },
//   imageContainer: {
//     display: 'flex',
//     flexDirection: 'column',
//     justifyContent: 'space-around',
//     alignItems: 'center',
//     gap: '30px',
//   },
//   image: {
//     width: '350px',
//     boxShadow: 'rgb(255, 255, 255) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px',
//     transition: '.3s ease-in-out 0s',
//   },
//   imageHover: {
//     transform: 'scale(1.03)',
//   },
// };

// const Git = () => {
//   return (
//     <div style={styles.container}>
//       <div data-aos="zoom-in-up">
//         <div style={{ ...styles.box, ...styles.boxHover }}>
//           <div
//             style={{
//               ...styles.innerBox,
//               width: { base: '100%', md: '70%', lg: '70%' },
//               padding: { base: '10px', md: '20px', lg: '20px' },
//             }}
//             className="react-activity-calendar"
//           >
//             <GitHubCalendar username="shashi310" />
//           </div>
//         </div>
//       </div>

//       <div style={styles.imageContainer}>
//         <div data-aos="zoom-in-up">
//           <img
//             src="https://github-readme-stats.vercel.app/api/top-langs/?username=shashi310&theme=dark&hide_border=false&include_all_commits=false&count_private=false&layout=compact"
//             id="github-top-langs"
//             style={{ ...styles.image, ...styles.imageHover, width: '100%' }}
//           />
//         </div>

//         <div data-aos="zoom-in-up">
//           <img
//             src="https://github-readme-streak-stats.herokuapp.com/?user=shashi310&theme=dark&hide_border=false"
//             id="github-streak-stats"
//             style={{ ...styles.image, ...styles.imageHover }}
//           />
//         </div>

//         <div data-aos="zoom-in-up">
//           <img
//             src="https://github-readme-stats.vercel.app/api?username=shashi310&theme=dark&hide_border=false&include_all_commits=false&count_private=false"
//             id="github-stats-card"
//             style={{ ...styles.image, ...styles.imageHover }}
//           />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Git;



import React from 'react';
import GitHubCalendar from "react-github-calendar";
// const styles = {
//   container: {
//     maxWidth: '90%',
//     margin: '0 auto',
//     display: 'flex',
//     flexDirection: 'column',
//   },
//   imageContainer: {
//     display: 'flex',
//     flexDirection: 'row',
//     justifyContent: 'space-around',
//     alignItems: 'center',
//     gap: '30px',
//   },
//   image: {
//     width: '350px',
//     boxShadow: 'rgb(255, 255, 255) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px',
//     transition: '.3s ease-in-out 0s',
//   },
//   imageHover: {
//     transform: 'scale(1.03)',
//   },

//   '@media (max-width: 768px)': {
//     imageContainer: {
//       flexDirection: 'column',
//     },
//   },
//   '@media (min-width: 769px)': {
//     imageContainer: {
//       flexDirection: 'row',
//     },
//   },
// };

const Git = () => {
  return (
    <div className="container" id="stats">
      <h1 style={{
      paddingTop: "20px",
      textAlign: "center"
    }}>Github Overview</h1>
<div data-aos="zoom-in-up">
      <div className="box boxHover">
        <div
          style={{ padding: '10px' }} // Override inline due to padding variation
          className="innerBox react-activity-calendar"
        >
          <GitHubCalendar username="shashi310" />
        </div>
      </div>
    </div>

      <div className="imageContainer">
        <div data-aos="zoom-in-up">
          <img
            src="https://github-readme-stats.vercel.app/api/top-langs/?username=shashi310&theme=dark&hide_border=false&include_all_commits=false&count_private=false&layout=compact"
            id="github-top-langs"
            style={{ width: '100%' }} // Overriding width inline due to width variation
            className="image imageHover"
          />
        </div>

        <div data-aos="zoom-in-up">
          <img
            src="https://github-readme-streak-stats.herokuapp.com/?user=shashi310&theme=dark&hide_border=false"
            id="github-streak-stats"
            className="image imageHover"
          />
        </div>

        <div data-aos="zoom-in-up">
          <img
            src="https://github-readme-stats.vercel.app/api?username=shashi310&theme=dark&hide_border=false&include_all_commits=false&count_private=false"
            id="github-stats-card"
            className="image imageHover"
          />
        </div>
      </div>
    </div>
  );
};

export default Git;



